/*
 * @Description: 
 * @Author: 姜暖阳
 * @Date: 2021-10-21 15:15:57
 * @LastEditTime: 2021-12-30 16:29:50
 * @LastEditors: 赵大壮
 * @Reference: 
 */
import config from '../nyConfig'
const ApiLogin = {
    "登录": new config({ url: '/manager/login', showSuccessMessage: true, useToken: false }),
    "修改密码": new config({ url: '/manager/editPwd', showSuccessMessage: true, useToken: true }),
}

export default ApiLogin
